<template>
  <div class="hotRequirement w1200">
    <div class="hotTitle">
      <p class="hotTitle_l">热门需求</p>
      <p class="hotTitle_r" @click="getMore">查看更多 ></p>
    </div>
    <div class="hotMesg">
      <div
        class="hotMesg_box"
        v-for="(item, index) in hotRequirementList"
        :key="index"
      >
        <p class="hotMesg_box_title ellipsis-1">{{ item.demandName }}</p>
        <div class="hotMesg_box_content">
          <p class="flex">
            <span style="white-space: nowrap;">需求方：</span>
            <span class="ellipsis-1">{{ item.creatorName }}</span>
          </p>
          <p class="flex">
            <span style="white-space: nowrap;">类&nbsp;&nbsp;&nbsp;型：</span>
            <span class="ellipsis-1">{{ item.demandTypeCn }}</span>
          </p>
        </div>
        <div class="hotMesg_box_bot">
          <div class="hotMesg_box_botMesg">
            <p class="hotMesg_box_botMesgP">发布时间</p>
            <p>{{ item.publishTime ? moment(item.publishTime).format("YYYY-MM-DD") : '' }}</p>
          </div>
          <div class="hotMesg_box_botMesg">
            <p class="hotMesg_box_botMesgP">截止时间</p>
            <p>{{ item.deadline }}</p>
          </div>
        </div>
        <div class="budget">
          <div class="budget_mbox">
            <p>预算金额</p>
            <h2 class="budget_m" v-if="item.budgetType == 0">{{ item.budgetPrice }}</h2>
            <h2 class="budget_m" v-else-if="item.budgetType == 1">{{ item.budgetMin +"-"+ item.budgetMax }}</h2>
            <h2 class="budget_m" v-else>无预算</h2>
          </div>
          <p class="budget_btn" @click="getDetails(item.id)">查看详情</p>
        </div>
      </div>
    </div>
    <div class="hotBtnBox">
      <el-button plain @click="openRequirement">发布需求</el-button>
      <p>贵企业如有生产、经营的需求，不妨发布平台，让专业服务商来找您</p>
    </div>
  </div>
</template>

<script>
import {getDemandsByPage} from "../../utils/interface";

export default {
  data() {
    return {
      hotRequirementList: [],
    };
  },
  created(){
      this.demandHotList();
  },
  methods: {
    demandHotList(){
      let params = {
        currentPage: 1,
        pageSize: 8,
      };
      getDemandsByPage(params).then((res)=>{
        this.hotRequirementList = res.data.records;
      })
    },
    getMore() {
      let routeData = this.$router.resolve({
        path: "/demandList",
      });
      window.open(routeData.href, "_blank");
    },
    getDetails(uuid) {
      let routeData = this.$router.resolve({
        path: `/demandDetails?uuid=${uuid}`,
      });
      window.open(routeData.href, "_blank");
    },
    openRequirement() {
      let routeData = this.$url.buyerWeb + `#/publishDemand`;
      if (routeData != "") {
        window.open(routeData, "_blank");
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import "./style/index.less";
p {
  margin: 0;
}
//   热门需求
.hotRequirement {
  margin: 20px auto 26px;
  .hotMesg {
    display: grid;
    grid-template-columns: 24% 24% 24% 24%;
    grid-gap: 16px;
    .hotMesg_box {
      box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
      background: #fafafc;
      border: 1px solid #fafafc;
      &:hover {
        border: 1px solid #2d50a1;
        .budget_btn {
          background: #009999;
          border: none;
          color: #fff !important;
        }
      }
      .hotMesg_box_title {
        font-size: 16px;
        padding: 16px;
        border-bottom: 1px dotted #cacaca;
        margin: 0 16px;
        font-weight: bold;
      }
      .hotMesg_box_content {
        font-size: 14px;
        padding: 0 16px;
        padding-top: 14px;
        line-height: 24px;
        .red {
          color: #d9001b;
        }
      }
      .hotMesg_box_bot {
        display: grid;
        grid-template-columns: 50% 50%;
        margin: 20px 16px;

        .hotMesg_box_botMesg {
          font-size: 16px;
          font-weight: bold;
          padding: 16px;
          text-align: center;
          color: #707070;
          &:nth-of-type(1) {
            border-right: 1px solid rgba(141, 141, 141, 0.334);
          }
          .hotMesg_box_botMesgP {
            font-size: 14px;
            color: #4f4f4f;
            font-weight: 400;

            margin-bottom: 16px;
          }
        }
      }
      .budget {
        background: #fff;
        padding: 13px 0 18px;
        .budget_mbox {
          margin: 0 auto;
          font-size: 14px;
          color: #333333;
          margin-bottom: 18px;
          display: flex;
          align-items: center;
          justify-content: center;
          .budget_m {
            font-size: 22px;
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #dc3223;
            margin-left: 9px;
          }
        }
        .budget_btn {
          width: 220px;
          text-align: center;
          padding: 12px;
          border: 1px solid #2d50a1;
          color: #009999;
          margin: 0 auto;
          cursor: pointer;
        }
      }
    }
  }
  .hotBtnBox {
    text-align: center;
    margin-top: 24px;
    button {
      border: 1px solid #2d50a1;
      color: #2d50a1;
      width: 140px;
      border-radius: 10px;
    }
    p {
      margin-top: 13px;
      font-size: 14px;
      color: #6e6e6e;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/supplyHome/hotRequirement.vue